const locales = [
  { name: 'Albanian', value: 'sq' },
  { name: 'Arabic', value: 'ar' },
  { name: 'Armenian', value: 'hy' },
  { name: 'Azerbaijani', value: 'az' },
  { name: 'Bosnian', value: 'bs' },
  { name: 'Bulgarian', value: 'bg' },
  { name: 'Chinese Simplified', value: 'cn' },
  { name: 'Chinese Traditional', value: 'zh-TW' },
  { name: 'Croatian', value: 'hr' },
  { name: 'Czech', value: 'cs' },
  { name: 'Danish', value: 'da' },
  { name: 'German', value: 'de' },
  { name: 'Dutch', value: 'nl' },
  { name: 'English', value: 'en' },
  { name: 'Estonian', value: 'et' },
  { name: 'Finnish', value: 'fi' },
  { name: 'French', value: 'fr' },
  { name: 'Japanese', value: 'jp' },
  { name: 'Georgian', value: 'ka' },
  { name: 'Greek', value: 'el' },
  { name: 'Hebrew', value: 'iw' },
  { name: 'Hungarian', value: 'hu' },
  { name: 'Italian', value: 'it' },
  { name: 'Kazakh', value: 'kk' },
  { name: 'Korean', value: 'kr' },
  { name: 'Latvian', value: 'lv' },
  { name: 'Lithuanian', value: 'lt' },
  { name: 'Maltese', value: 'mt' },
  { name: 'Norwegian', value: 'no' },
  { name: 'Persian', value: 'fa' },
  { name: 'Polish', value: 'pl' },
  { name: 'Portuguese', value: 'pt' },
  { name: 'Portuguese (Brazil)', value: 'pt-BR' },
  { name: 'Romanian', value: 'ro' },
  { name: 'Russian', value: 'ru' },
  { name: 'Serbian', value: 'sr' },
  { name: 'Slovak', value: 'sk' },
  { name: 'Slovenian', value: 'sl' },
  { name: 'Spanish', value: 'es' },
  { name: 'Swahili', value: 'sw' },
  { name: 'Swedish', value: 'sv' },
  { name: 'Thai', value: 'th' },
  { name: 'Turkish', value: 'tr' },
  { name: 'Ukrainian', value: 'uk' },
  { name: 'Vietnamese', value: 'vi' },
];

export default locales;
